import http from '@/http.js';
import { ref, onMounted } from 'vue';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useTesterRequete(props, {emit}) {
    const saisieMap = ref({});
    const saisieToSend = ref({});
    const showModalTesterRequete = ref(true);

    const toastMessage = ref("");
    const showNotification = ref(false);
    const toastType = ref("info");
    const duration = ref(5000);

    const initializeSaisieParams = () => {
        saisieMap.value = props.parametres.reduce((acc, param) => {
            acc[param.idParametre] = '';
            return acc;
        }, {});
    };

    const TesterRequete = async () => {
        const saisiesArray = Object.entries(saisieMap.value).map(([idParametre, saisie]) => ({
            idParametre: parseInt(idParametre), // Convertir l'ID en entier si nécessaire
            saisie
        }));
        saisieToSend.value = {
            idRequete: props.idRequete,
            saisies: saisiesArray,
            sql: props.sql,
        };

        try {
            const data = await http.testerRequete(saisieToSend.value);
            if (data.resultatTest !== false) {
                emit('close');
                emit('notification', {
                    showNotification: true,
                    toastMessage: `La requête envoyée est ${data.sql}. Elle fonctionne sur le système d'information.`,
                    toastType: "success",
                });
            } else {
                emit('close');
                emit('notification', {
                    showNotification: true,
                    toastMessage: "La requête est incorrecte",
                    toastType: "danger",
                });
            }
        } catch (error) {
            emit('close');
            emit('notification', {
                showNotification: true,
                toastMessage: "Erreur lors de la vérification de la requête",
                toastType: "danger",
            });
        }
    };

    onMounted(() => {
        initializeSaisieParams();
    });

    return {
        saisieMap,
        showModalTesterRequete,
        TesterRequete,
        toastMessage,
        showNotification,
        toastType,
        duration,
    };
}